import React, { useState } from "react";
import StaffDebriefListManager from "./staffDebriefManagerForms/staff-debrief-list-manager";
import StaffMemberManager from "./staffDebriefManagerForms/staff-member-manager";

const StaffDebriefManager = ({ task, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0); // Step index

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <StaffDebriefListManager debriefData={task?.staffDebriefInfo} nextStep={nextStep} />;
      case 1:
        return (
          <StaffMemberManager
            memberData={task?.staffMemberInfo}
            selectedStaff={task?.selectedStaff}
            prevStep={prevStep}
            handleSubmit={onClose}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default StaffDebriefManager;
